import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "user-login",
  class: "user-wrapper"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"login-brand\"><span class=\"lb-mark\" aria-hidden=\"true\"><svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M3 8h11a3 3 0 1 0-3-3\"></path><path d=\"M3 12h15a3 3 0 1 1-3 3\"></path><path d=\"M3 16h9\"></path></svg></span><div class=\"lb-title\">breezer 로그인</div><div class=\"lb-sub\">계정 하나로 모든 서비스를 이용하세요</div></div>", 1)
const _hoisted_3 = { class: "input-area" }
const _hoisted_4 = { class: "check-area" }
const _hoisted_5 = { class: "checkbox-container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "아이디 저장", -1)
const _hoisted_8 = { class: "checkbox-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "로그인 유지", -1)
const _hoisted_11 = { class: "desc-area" }
const _hoisted_12 = { class: "desc" }
const _hoisted_13 = { class: "button-area" }
const _hoisted_14 = { class: "login-button-area" }
const _hoisted_15 = { class: "etc-button-area" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "sns-login-area" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("form", {
      class: "login-wrapper",
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          placeholder: "아이디",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.id) = $event)),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.login()), ["enter"])),
          autocomplete: "username",
          required: ""
        }, null, 544), [
          [_vModelText, _ctx.id]
        ]),
        _withDirectives(_createElementVNode("input", {
          placeholder: "비밀번호",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
          type: "password",
          onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.login()), ["enter"])),
          autocomplete: "current-password",
          required: ""
        }, null, 544), [
          [_vModelText, _ctx.password]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rememberId) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.rememberId]
          ]),
          _hoisted_6,
          _hoisted_7
        ]),
        _createElementVNode("label", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.autoLogin) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.autoLogin]
          ]),
          _hoisted_9,
          _hoisted_10
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.message), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "login-button button",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.login()))
          }, "로그인")
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("label", {
            class: "join-button btn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clickJoin()))
          }, "회원가입 |"),
          _createElementVNode("label", {
            class: "find-account-button btn",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clickFindAccount()))
          }, "아이디/비밀번호 찾기")
        ])
      ]),
      _hoisted_16
    ], 32)
  ]))
}